import React from 'react';

const Cross = () => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.0002 20.1667C16.0418 20.1667 20.1668 16.0417 20.1668 11C20.1668 5.95833 16.0418 1.83333 11.0002 1.83333C5.9585 1.83333 1.8335 5.95833 1.8335 11C1.8335 16.0417 5.9585 20.1667 11.0002 20.1667Z"
            stroke="#B1ADB3"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.40576 13.5942L13.5941 8.40583"
            stroke="#B1ADB3"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.5941 13.5942L8.40576 8.40583"
            stroke="#B1ADB3"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Cross;
